//对接后台错误码

var errorType = {};

const errMsg = {
  text:{
    pleaseSelectAStoragePeriod:"请选择存储期限",//请选择存储期限
    currentlySelectedStorage:"当前所选存储期限小于原选期限",//当前所选存储期限小于原选期限

  },
  //数据字典类型
  dict: {},
  //批量导入后台返回
  0x00000: {
    message: "账号{account}已存在"
  },
  0x00001: {
    message: "账号{account}，请重新检查下群组是否正确！"
  },
  0x00005: {
    message: '存在重复账号',
  },
  0x00104: {
    message: '参数错误.',
  },
  0x00060: {
    message: '群组中用户数量超出规定值',
  },
  common: {
    0x00002: {
      message: "账号或密码错误!"
    },
    0x00003: {
      message: "账号已停用"
    },
    0x00004: {
      message: "账号或密码错误!!"
    },
    100043:{
      message: "用户没有调度权限!"
    },
    100044:{
      message: "用户没有设置权限!"
    },
    100045:{
      message: "账号没有设置调度功能!"
    },
    100046:{
      message: "用户没有功能项!"
    },
  },
  //Q币相关的异常信息
  0x00014: {
    message: "目标可操作Q币不足!"
  },
  0x00015: {
    message: "终端Q币上限!"
  },
  0x00016: {
    message: "目标已激活，不可回收！"
  },
  100001: {
    message: "iccid为空"
  },
  100002: {
    message: "不属于系统中的iccid"
  },
  100003: {
    message: "数据中有iccid已经绑定企业"
  },
  100004: {
    message: "该区间生成的数据中已有绑定企业id"
  },
  100005: {
    message: "iccid已经存在"
  },
  100006: {
    message: "区间数据中有iccid重复"
  },
  100007: {
    message: "批量新增的数据中有iccid重复"
  },
  100008: {
    message: "解绑失败"
  },
  100009: {
    message: "该iccid不属于任何企业"
  },
  100010: {
    message: "该iccid不属于这个企业"
  },
  100011: {
    message: "该iccid已经绑定了用户"
  },
  100012: {
    message: "物联网卡号为空"
  },
  100013: {
    message: "该iccid没有绑定用户"
  },
  100014: {
    message: "后4位只能是数字"
  },
  100015: {
    message: "一次最多只能创建100个用户"
  },
  100016: {
    message: "数据不满足格式要求"
  },
  100017: {
    message: "企业Q币数量不足"
  },
  100018: {
    message: "iccid的长度只能是20位"
  },
  100019: {
    message: "iccid的公共部分不相同"
  },
  100020: {
    message: "后4位只能是数字"
  },
  100021: {
    message: "连号结束的数字不能比开始的数字小"
  },
  100022: {
    message: "企业id不能为空"
  },
  100023: {
    message: "这不是企业"
  },
  100024: {
    message: "没有进行IMEI创建或iccid连号创建"
  },
  100025: {
    message: "数据："
  },
  100026: {
    message: "长度不符合条件"
  },
  100027: {
    message: "不符合格式要求"
  },
  100028: {
    message: "密码:"
  },
  100029: {
    message: "不符合6-15 字母或者数字的要求"
  },
  100030: {
    message: "组名:"
  },
  100031: {
    message: "只能是2-10字符"
  },
  100032: {
    message: "重复"
  },
  100033: {
    message: "账号:"
  },
  100034: {
    message: "不符合6-15 字母或者数字的要求"
  },
  100035: {
    message: "要生成账号:"
  },
  100036: {
    message: "一次最多只能新增100个用户"
  },
  100037:{
    message: "更新失败"
  },
  100038:{
    message: "iccid号码错误或者不存在"
  },
  100039:{
    message: "在用状态!不能进行二次激活操作"
  },
  100040:{
    message: "该号码已有业务正在处理，请稍后下发"
  },
  100041:{
    message: "查询失败"
  },
  100042:{
    message: "群组中用户数量超出规定!"
  },

  100050:{
    message: "该订单号不存在!"
  },

  500:{
    message: "服务器内部错误!"
  },





};

export default errMsg;



// WEBPACK FOOTER //
// ./src/api/lang/modules/error/errMsg_zh.js